"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainContainer = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var animation = (0, styled_components_1.keyframes)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"], ["\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"])));
var MainContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-block;\n  width: 80px;\n  height: 80px;\n\n  &:after {\n    content: \" \";\n    display: block;\n    width: 50px;\n    height: 50px;\n    margin: 8px;\n    border-radius: 50%;\n    border: 4px solid ", ";\n    border-color: ", ";\n    animation: ", " 1.2s linear infinite;\n  }\n"], ["\n  display: inline-block;\n  width: 80px;\n  height: 80px;\n\n  &:after {\n    content: \" \";\n    display: block;\n    width: 50px;\n    height: 50px;\n    margin: 8px;\n    border-radius: 50%;\n    border: 4px solid ", ";\n    border-color: ", ";\n    animation: ", " 1.2s linear infinite;\n  }\n"])), function (_a) {
    var color = _a.color;
    return color;
}, function (_a) {
    var color = _a.color;
    return "".concat(color, " transparent ").concat(color, " transparent");
}, animation);
exports.MainContainer = MainContainer;
var templateObject_1, templateObject_2;
//# sourceMappingURL=styles.js.map